import { render } from "./AuthIndex.vue?vue&type=template&id=34cc6f76"
import script from "./AuthIndex.vue?vue&type=script&lang=js"
export * from "./AuthIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__